import { useQuery } from '@apollo/client/react';
import { gql } from '@apollo/client';

export const USERS_QUERY = gql`
  query Users {
    users {
      id
      email
      fullName
      role
      disabled
      disabledAt
      forcePasswordChange
      createdAt
      updatedAt
    }
  }
`;

export function useUsers() {
  const { data, loading, error, refetch } = useQuery(USERS_QUERY, {
    fetchPolicy: 'network-only',
  });

  return {
    users: (data as any)?.users || [],
    loading,
    error,
    refetch,
  };
}
